import {
  format,
  intervalToDuration,
  intlFormatDistance,
  parseISO,
  formatDuration as FNS_formatDuration,
  setDefaultOptions,
  FormatDurationOptions,
  isBefore,
} from "date-fns";
import { fr } from "date-fns/locale/fr";

setDefaultOptions({ locale: fr });

export const processDateInput = (input) => {
  if (input instanceof Date) {
    return input;
  }

  // if input is string containing only numbers convert it using new Date
  if (typeof input === "string" && input.match(/^\d+$/)) {
    return new Date(parseInt(input.slice(0, 13), 10));
  } else {
    return parseISO(input);
  }
};

export const formatDate = (input, _format = "dd/MM/yyyy") => {
  if (!input) {
    return null;
  }

  const date = processDateInput(input);

  return format(date, _format, { locale: fr });
};

export const formatDateTime = (
  input,
  withSeconds = false,
  _format = `dd/MM/yyyy HH:mm${withSeconds ? ":ss" : ""}`
) => formatDate(input, _format);

export const formatTime = (
  input,
  withSeconds = false,
  _format = `HH:mm${withSeconds ? ":ss" : ""}`
) => formatDate(input, _format);

export const formatRelativeTime = (input) => {
  if (!input) {
    return null;
  }

  const date = processDateInput(input);

  const duration = intervalToDuration({
    start: date,
    end: new Date(),
  });

  if ([duration.years, duration.months, duration.days].some((v) => v > 0)) {
    return formatDateTime(date);
  }

  return intlFormatDistance(date, new Date(), {
    locale: "fr",
  });
};

export const formatDuration = (
  start,
  end,
  { absolute, ...options } = {} as FormatDurationOptions & { absolute: boolean }
) => {
  if (!start || !end) {
    return null;
  }

  let _start = processDateInput(start);
  let _end = processDateInput(end);

  if (_start.getTime() > _end.getTime() && absolute) {
    _start = processDateInput(end);
    _end = processDateInput(start);
  }

  return FNS_formatDuration(
    intervalToDuration({
      start: _start,
      end: _end,
    }),
    options
  );
};

export const formatBirthdate = (
  start,
  end,
  options: { [key: string]: any } = {}
) => {
  if (!start || !end) {
    return null;
  }

  const interval = intervalToDuration({
    start: processDateInput(start),
    end: processDateInput(end),
  });

  return FNS_formatDuration(interval, {
    ...options,
    format: [
      ...options.format,
      interval.years === 0 ? "months" : "",
      interval.years === 0 ? "days" : "",
    ],
  });
};

export const nowIsInRange = (start: Date, end: Date) =>
  isBefore(start, new Date()) && !isBefore(end, new Date());
